import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Polyline as VisPolyline } from '@vis.gl/react-google-maps';
import { useReportBounds } from "../lib/BoundsRegistry";
const toLiteral = (p) => typeof p.lat === 'function'
    ? { lat: p.lat(), lng: p.lng() }
    : { lat: p.lat, lng: p.lng };
export const Polyline = ({ path, strokeColor, strokeOpacity, strokeWeight }) => {
    useReportBounds(useMemo(() => path.map(toLiteral), [path]));
    return (_jsx(VisPolyline, { path: path, strokeColor: strokeColor ?? '#000000', strokeOpacity: strokeOpacity ?? 1.0, strokeWeight: strokeWeight ?? 4 }));
};
